import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetEk83ReportListPagingAndFilterResponse, GetEk83ReportListPagingAndFilterResponseData, GetEk83ReportListPagingAndFilterResponseItem, initialGetEk83ReportListPagingAndFilterResponseData } from '../../../models/response/report/GetEk83ReportListPagingAndFilterResponse';
import { GetEk83ReportListPagingAndFilterRequest, initialGetEk83ReportListPagingAndFilterRequest } from '../../../models/request/report/GetEk83ReportListPagingAndFilterRequest';
import { ReportService } from '../../../services/ReportService';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import Ek83ReportListFilters from './Components/Ek83ReportListFilters';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { ExportEk83ReportListResponse } from '../../../models/response/report/ExportEk83ReportListResponse';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const Ek83ReportList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Raporlar > Ek-83 Raporu"
    const pageVersion = "1";
    const [data, setData] = useState<GetEk83ReportListPagingAndFilterResponseData>(initialGetEk83ReportListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetEk83ReportListPagingAndFilterRequest>(initialGetEk83ReportListPagingAndFilterRequest)
    const [isFirstTime, setIsFirstTime] = useState(true);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Türü', name: 'turu', order: 0, isVisible: true },
            { title: 'Sıra No', name: 'siraNo', order: 0, isVisible: true },
            { title: 'Antrepo Beyanname No', name: 'antrepoBeyannameNo', order: 0, isVisible: true },
            { title: 'Tescil Tarihi', name: 'tescilTarihi', order: 0, isVisible: true },
            { title: 'Kalem No', name: 'kalemNo', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Rejim Kodu', name: 'rejimKodu', order: 0, isVisible: true },
            { title: 'GTIP', name: 'gtip', order: 0, isVisible: true },
            { title: 'Ticari Tanımı', name: 'ticariTanimi', order: 0, isVisible: true },
            { title: 'Kap İçinde / Dökme', name: 'kapIcindeDokme', order: 0, isVisible: true },
            { title: 'Giriş Kap Adet', name: 'girisKapAdet', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Marka - No', name: 'markaNo', order: 0, isVisible: true },
            { title: 'Konteyner No', name: 'konteynerNo', order: 0, isVisible: true },
            { title: 'Giriş Brüt Kilo', name: 'girisBrutKilo', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Giriş Net Kilo', name: 'girisNetKilo', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Giriş Satışa Esas Birim', name: 'girisSatisaEsasBirim', order: 0, isVisible: true },
            { title: 'Giriş Miktar', name: 'girisMiktar', order: 0, isVisible: true },
            { title: 'Özet Beyan / Önceki Beyan No', name: 'ozetBeyanNo', order: 0, isVisible: true },
            { title: 'Girişte Toplam Kap', name: 'giristeToplamKap', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Antrepoya Giriş Tarihi', name: 'antrepoyaGirisTarihi', order: 0, isVisible: true },
            { title: 'Taşıtın Adı', name: 'tasitinAdi', order: 0, isVisible: true },
            { title: 'Plaka / Sefer No', name: 'plaka', order: 0, isVisible: true },
            { title: 'Teminat Türü', name: 'teminatTuru', order: 0, isVisible: true },
            { title: 'Tutarı', name: 'tutari', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Çıkış Beyanname No', name: 'cikisBeyannameNo', order: 0, isVisible: true },
            { title: 'Çıkış Kalem No', name: 'cikisKalemNo', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Çıkışta Kap / Miktar', name: 'cikistaKapMiktar', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Çıkış Satışa Esas Birim', name: 'cikisSatisaEsasBirim', order: 0, isVisible: true },
            { title: 'Çıkış Satışa Esas Miktar', name: 'cikisSatisaEsasMiktar', order: 0, isVisible: true },
            { title: 'Kalan Kap', name: 'kalanKap', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Mal Çıkış Tarih', name: 'malCikisTarih', order: 0, isVisible: true },
            { title: 'Devir Tarihi', name: 'devirTarihi', order: 0, isVisible: true },
            { title: 'İlgili Gümrük Beyannamesi', name: 'ilgiliGumrukBeyannamesi', order: 0, isVisible: true },
            { title: 'Varsa aynı Gümrük İdaresindeki Antrepolar Arası Eşya Sevkinde Kullanılan Belge no ve Tarihi', name: 'varsaAyniGumrukIdaresindekiAntrepolarArasiEsyaSevkindeKullanilanBelgenoVeTarihi', order: 0, isVisible: true },
            { title: 'Varsa Elleçlemeye İlişkin Bilgiler', name: 'varsaElleclemeyeIliskinBilgiler', order: 0, isVisible: true },
            { title: 'Varsa Geçici Çıkışa İlişkin Bilgiler', name: 'varsaGeciciCikisaIliskinBilgiler', order: 0, isVisible: true },
            { title: 'Diğer Bilgiler', name: 'digerBilgiler', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'aciklama', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetEk83ReportListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            if (!isFirstTime && (Helpers.isEmpty(_filter.startDate) || Helpers.isEmpty(_filter.endDate))) {
                toast.error('Başlangıç Tarihi ve Bitiş Tarihi alanları zorunludur!')
                return;
            }

            setIsFirstTime(false);

            dispatch(storeActivityIndicator(true))

            var response: GetEk83ReportListPagingAndFilterResponse = await ReportService.getEk83ReportListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportEk83ReportListResponse = await ReportService.exportEk83ReportList(buildExcelRequest(filter, mode, [], columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (ReportManager.ApplyEk83ColumnFilters) aynı. Hep boş gelen kolonlar ve sabit Rejim Kodu filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        turu: {
            type: 'select',
            allowEmpty: false,
            loadOptions: () => Promise.resolve([{ value: '1', label: 'Giriş' }, { value: '0', label: 'Çıkış' }])
        },
        siraNo: { type: 'text' },
        antrepoBeyannameNo: { type: 'text' },
        tescilTarihi: { type: 'date' },
        kalemNo: { type: 'number' },
        gtip: { type: 'text' },
        ticariTanimi: { type: 'text' },
        kapIcindeDokme: { type: 'text' },
        girisKapAdet: { type: 'number' },
        konteynerNo: { type: 'text' },
        girisBrutKilo: { type: 'number' },
        girisNetKilo: { type: 'number' },
        ozetBeyanNo: { type: 'text' },
        giristeToplamKap: { type: 'number' },
        antrepoyaGirisTarihi: { type: 'date' },
        tasitinAdi: { type: 'text' },
        plaka: { type: 'text' },
        teminatTuru: { type: 'text' },
        tutari: { type: 'number' },
        cikisBeyannameNo: { type: 'text' },
        cikisKalemNo: { type: 'number' },
        cikistaKapMiktar: { type: 'number' },
        kalanKap: { type: 'number' },
        malCikisTarih: { type: 'date' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetEk83ReportListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (['girisKapAdet', 'giristeToplamKap', 'cikistaKapMiktar', 'kalanKap', 'kalemNo', 'cikisKalemNo'].includes(column)) {
            var item2: any = item;
            return <td className={className}>{Helpers.correctPrice(item2[column], 0)}</td>;
        }
        else if (['girisBrutKilo', 'girisNetKilo', 'tutari'].includes(column)) {
            var item2: any = item;
            return <td className={className}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <Ek83ReportListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    {/* Arama kutusu kaldırıldı (22.09.2026): raporda hiç çalışmıyordu; kolon
                        başlıklarının altındaki filtreler kullanılır. */}

                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default Ek83ReportList;